import { DERElement } from '~/common/der-element';

export default class DERFormElement extends DERElement {
    static formAssociated = true;
    protected _internals: ElementInternals;

    constructor() {
        super();
        this._internals = this.attachInternals();
    }

    setDERValidity(flags?: ValidityStateFlags, message?: string, anchor?: HTMLElement) {
        const currentValid = this._internals.validity.valid;
        this._internals.setValidity(flags, message, anchor);
        const newValid = this._internals.validity.valid;

        if (currentValid !== newValid) {
            this.emitEvent('der.validity-change', {
                validity: this._internals.validity,
                validationMessage: message,
                element: anchor || this,
            });
        }
    }

    override error(name: string, data: object) {
        const detail = { name: name.toLowerCase(), data };

        this.dispatchEvent(new CustomEvent('der.error', { detail, bubbles: true, composed: true }));
    }
}
